// import React from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
//   AreaChart,
//   Area,
// } from "recharts";
// import "./SevenDayGraph.scss";

// export default function SevenDayGraph() {
//   // ✅ Dummy data (7 days)
//   const dummyData = [
//     { day: "Mon", tasks: 5, todos: 3, lists: 1 },
//     { day: "Tue", tasks: 8, todos: 4, lists: 2 },
//     { day: "Wed", tasks: 6, todos: 5, lists: 2 },
//     { day: "Thu", tasks: 2, todos: 3, lists: 1 },
//     { day: "Fri", tasks: 9, todos: 6, lists: 3 },
//     { day: "Sat", tasks: 7, todos: 5, lists: 2 },
//     { day: "Sun", tasks: 10, todos: 8, lists: 4 },
//   ];

//   return (
//     <div className="sevenDayGraph-card">
//       <div className="sevenDayGraph-header">
//         <h3>Weekly Progress (Tasks / Todos / Todo Lists)</h3>
//       </div>

//       <ResponsiveContainer width="100%" height={260}>
//         <AreaChart
//           data={dummyData}
//           margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
//         ><defs>
//   <linearGradient id="colorTasks" x1="0" y1="0" x2="0" y2="1">
//     <stop offset="8%" stopColor="#6C63FF" stopOpacity={0.28} />
//     <stop offset="95%" stopColor="#6C63FF" stopOpacity={0} />
//   </linearGradient>

//   <linearGradient id="colorTodos" x1="0" y1="0" x2="0" y2="1">
//     <stop offset="8%" stopColor="#FFA726" stopOpacity={0.26} />
//     <stop offset="95%" stopColor="#FFA726" stopOpacity={0} />
//   </linearGradient>

//   <linearGradient id="colorLists" x1="0" y1="0" x2="0" y2="1">
//     <stop offset="8%" stopColor="#8E44AD" stopOpacity={0.22} />
//     <stop offset="95%" stopColor="#8E44AD" stopOpacity={0} />
//   </linearGradient>
// </defs>


//           <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
//           <XAxis
//   dataKey="day"
//   tick={{ fill: "#555", fontSize: 12 }}
//   axisLine={false}   // removes the X axis line
//   tickLine={false}   // removes small tick marks
// />
// <YAxis
//   tick={{ fill: "#555", fontSize: 12 }}
//   axisLine={false}   // removes the Y axis line
//   tickLine={false}   // removes small tick marks
// />

//           <Tooltip
//             contentStyle={{
//               backgroundColor: "#fff",
//               border: "1px solid #ccc",
//               borderRadius: "8px",
//               fontSize: "0.85rem",
//             }}
//           />

//           {/* Task line */}
//        <Area
//   type="monotone"
//   dataKey="tasks"
//   name="Tasks"
//   stroke="#6C63FF"
//   strokeWidth={2.2}
//   fill="url(#colorTasks)"
//   dot={{ r: 3, fill: "#6C63FF", stroke: "#fff", strokeWidth: 1.5 }}
//   activeDot={{ r: 5 }}
// />

// <Area
//   type="monotone"
//   dataKey="todos"
//   name="Todos"
//   stroke="#FFA726"
//   strokeWidth={2.2}
//   fill="url(#colorTodos)"
//   dot={{ r: 3, fill: "#FFA726", stroke: "#fff", strokeWidth: 1.5 }}
// />

// <Area
//   type="monotone"
//   dataKey="lists"
//   name="Todo Lists"
//   stroke="#8E44AD"
//   strokeWidth={2.2}
//   fill="url(#colorLists)"
//   dot={{ r: 3, fill: "#8E44AD", stroke: "#fff", strokeWidth: 1.5 }}
// />

//         </AreaChart>
//       </ResponsiveContainer>

//       {/* Custom Legend */}
//       <div className="graph-legend">
//         <div className="legend-item">
//           <span className="dot tasks"></span> Blue: Tasks
//         </div>
//         <div className="legend-item">
//           <span className="dot todos"></span> Orange: Todos
//         </div>
//         <div className="legend-item">
//           <span className="dot lists"></span> Purple: Todo Lists
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import axiosInstance from "../../axiosInstace";
import "./SevenDayGraph.scss";

export default function SevenDayGraph() {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // helper: convert date string to short weekday (Mon, Tue...)
  const getDayName = (dateStr) => {
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-US", { weekday: "short" });
    } catch {
      return "";
    }
  };

  useEffect(() => {
    async function fetchGraphData() {
      setLoading(true);
      setError(null);
      try {
        const res = await axiosInstance.get("/api/emp/counts/cumulative-last-7-days");
        const data = Array.isArray(res?.data?.data) ? res.data.data : [];

        // transform response to recharts-friendly format
        const formatted = data.map((item) => ({
          day: getDayName(item.date),
          tasks: Number(item.completedTasks ?? 0),
          todos: Number(item.completedToDos ?? 0),
          lists: Number(item.completedToDoList ?? 0),
        }));

        setGraphData(formatted);
      } catch (err) {
        console.error("Failed to fetch 7-day graph data", err);
        setError("Unable to load weekly progress");
      } finally {
        setLoading(false);
      }
    }

    fetchGraphData();
  }, []);

  if (loading)
    return <div className="sevenDayGraph-card">Loading..</div>;
  if (error)
    return <div className="sevenDayGraph-card error">{error}</div>;

  return (
    <div className="sevenDayGraph-card">
      <div className="sevenDayGraph-header">
        <h3>Weekly Progress (Stages/ Tasks/ Todolist)</h3>
      </div>

      <ResponsiveContainer width="100%" height={260}>
        <AreaChart
          data={graphData}
          margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
        >
          <defs>
            <linearGradient id="colorTasks" x1="0" y1="0" x2="0" y2="1">
              <stop offset="8%" stopColor="#6C63FF" stopOpacity={0.28} />
              <stop offset="95%" stopColor="#6C63FF" stopOpacity={0} />
            </linearGradient>

            <linearGradient id="colorTodos" x1="0" y1="0" x2="0" y2="1">
              <stop offset="8%" stopColor="#FFA726" stopOpacity={0.26} />
              <stop offset="95%" stopColor="#FFA726" stopOpacity={0} />
            </linearGradient>

            <linearGradient id="colorLists" x1="0" y1="0" x2="0" y2="1">
              <stop offset="8%" stopColor="#8E44AD" stopOpacity={0.22} />
              <stop offset="95%" stopColor="#8E44AD" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis
            dataKey="day"
            tick={{ fill: "#555", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: "#555", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "0.85rem",
            }}
          />

          <Area
            type="monotone"
            dataKey="tasks"
            name="Stage"
            stroke="#6C63FF"
            strokeWidth={2.2}
            fill="url(#colorTasks)"
            dot={{ r: 3, fill: "#6C63FF", stroke: "#fff", strokeWidth: 1.5 }}
            activeDot={{ r: 5 }}
          />

          <Area
            type="monotone"
            dataKey="todos"
            name="Task"
            stroke="#FFA726"
            strokeWidth={2.2}
            fill="url(#colorTodos)"
            dot={{ r: 3, fill: "#FFA726", stroke: "#fff", strokeWidth: 1.5 }}
          />

          <Area
            type="monotone"
            dataKey="lists"
            name="Todo"
            stroke="#8E44AD"
            strokeWidth={2.2}
            fill="url(#colorLists)"
            dot={{ r: 3, fill: "#8E44AD", stroke: "#fff", strokeWidth: 1.5 }}
          />
        </AreaChart>
      </ResponsiveContainer>

      <div className="graph-legend">
        <div className="legend-item">
          <span className="dot tasks"></span> Stage
        </div>
        <div className="legend-item">
          <span className="dot todos"></span> Task
        </div>
        <div className="legend-item">
          <span className="dot lists"></span> TodoList
        </div>
      </div>
    </div>
  );
}
